import { render } from "./filtro.vue?vue&type=template&id=bfe6a148"
import script from "./filtro.vue?vue&type=script&lang=js"
export * from "./filtro.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__